/*
  ⌛ 🌎 LEGACY keys - across ALL companies
  These keys need to be migrated to new keys that follow this format:
  pz:name-of-the-feature
*/

/**
 * @deprecated Use CURRENT_ACTIVE_COMPANY instead.
 */
export const ACTIVE_COMPANY = "activeCompany";

/*
  ⌛ 🔍 LEGACY keys - SPECIFIC to a company
  These keys follow the same format, but the company ID is appended to the key in its creation code:
  pz:name-of-the-feature:company:id-of-the-company
*/

export const MINIMIZED_SIDEBAR = "minimized-sidebar";
export const LAST_VIEWED_SUBSTEP = "intro:current_company_substep_position_by_company";

/*
  ✨ 🌎 NEW keys - across ALL companies
  These keys follow this format:
  pz:name-of-the-feature
*/

export const CURRENT_ACTIVE_COMPANY = "pz:current-active-company";

/*
  ✨ 🔍 NEW keys - SPECIFIC to a company
  These keys follow the same format, but the company ID is appended to the key in its creation code:
  pz:name-of-the-feature:company:id-of-the-company
*/
export const THEME_KEY = "pz:theme-mode";
export const STRIPE_DETAIL_PAGE_SIZE = "pz:stripe-detail-page-size";
export const DASHBOARD_METRIC_CARDS_COLLAPSED = "pz:dashboard-metric-cards-collapsed";
export const TRANSACTIONS_PAGE_SIZE = "pz:transactions-mrt-page-size";
export const TRANSACTIONS_COLUMN_VISIBILITY = "pz:transactions-mrt-col-vis";
export const TRANSACTIONS_COLUMN_ORDER = "pz:transactions-mrt-col-order-2";
export const ASK_AI_CACHE_KEY_PREFIX = "pz:ask-ai-cache:";

export function getTransactionsColumnSizes(companyId: string) {
  return `pz:transactions-column-sizes:company:${companyId}`;
}
